import { TaskFileModel } from "./TaskFileModel";

/**
 * * Модель данных для перемещения на другую страницуя
 */
export class TaskFormDataTransferModel {
  /**ID папки с файлами */
  FolderId?: string;
  /**Название */
  Name: string = "";
  /**Описание */
  Description?: string;
  /**Статус */
  StatusId!: number;
  /**Тип задачи */
  TypeId!: string;
  /**Приортите */
  PriorityId!: number;
  /**Уровень сложности */
  DifficultyId!: string;
  /**Исполнители */
  PerformerIds: Array<number> = [];
  /**Наблюдатели */
  ObserverIds: Array<number> = [];
  /**Дата дедлайна */
  DeadlineDate: Date = new Date();
  /**Список тегов */
  Tags: Array<number> = [];
  /**Список файлов */
  Files: Array<TaskFileModel> = [];

  constructor(obj?: Partial<TaskFormDataTransferModel>) {
    Object.assign(this, obj);
  }
}
